import { useEffect, useState } from 'react';

// true se il viewport rispetta la media query (default: telefono), aggiornato
// a resize/rotazione. Da usare solo quando il layout cambia davvero struttura
// (es. campo verticale): per il resto bastano le media query CSS.
export default function useIsMobile(query = '(max-width: 640px)') {
  const get = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false);
  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
